import React from 'react';

const StatusBar = ({ content, lastSavedAt }) => {
  const charCount = (content || '').length;

  const formatTime = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return date.toLocaleTimeString('ko-KR', {
      timeZone: 'Asia/Seoul',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  const savedTime = formatTime(lastSavedAt);

  return (
    <div className="bear-statusbar">
      <span className="bear-statusbar-item">
        {charCount.toLocaleString()}자
      </span>
      {savedTime && (
        <span className="bear-statusbar-item">
          마지막 저장 {savedTime}
        </span>
      )}
    </div>
  );
};

export default StatusBar;
